import React from 'react';
import Icon from '../ui/Icon';
import type { EnterpriseCredentialConfig } from '../../themes/themeTypes';

interface CredentialsBarProps {
  credentials?: EnterpriseCredentialConfig[];
}

/**
 * Displays enterprise credentials (ISO, GDPR, SOC 2, etc.) as a trust-signal bar.
 * Rendered on B2B-oriented stores below the hero.
 */
const CredentialsBar: React.FC<CredentialsBarProps> = ({ credentials }) => {
  if (!credentials || credentials.length === 0) return null;

  return (
    <section
      className="bg-bg-secondary border-y border-border-light"
      aria-label="Certifications and credentials"
      data-testid="credentials-bar"
    >
      <div
        className="container mx-auto px-lg py-lg"
        style={{ maxWidth: 'var(--container-max-width)' }}
      >
        <ul className="flex flex-wrap items-center justify-center gap-xl list-none p-0 m-0">
          {credentials.map((cred) => (
            <li
              key={cred.title}
              className="flex items-center gap-sm text-text-secondary"
            >
              {cred.icon && (
                <span
                  className="text-accent"
                  aria-hidden="true"
                >
                  <Icon name={cred.icon} size={20} />
                </span>
              )}
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-text-primary">
                  {cred.title}
                </span>
                {cred.description && (
                  <span className="text-xs text-text-light">
                    {cred.description}
                  </span>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CredentialsBar;
